import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ThemeMode } from 'src/app/base/services/theme.model';

@Component({
  selector: 'app-theme-mode-switcher',
  templateUrl: './theme-mode-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, AsyncPipe]
})
export class ThemeModeSwitcherComponent {
  @Input() public currentThemeMode$!: Observable<ThemeMode>;
  @Output() public modeChange = new EventEmitter<ThemeMode>();

  public setTheme(mode: ThemeMode): void {
    this.modeChange.emit(mode);
  }
}
